import Flex from 'components/Flex'
import InputNumber from 'components/Form/InputNumber'
import styled from 'styled-components'

export const RangeDiv = styled(Flex)`
  width: 46%;
  margin-bottom: 10px;
`
export const Wrapper = styled(Flex)`
  gap: 1rem;
  flex-wrap: ${props => props.wrap ? 'wrap' : 'nowrap'};
  width: ${props => props.width || '100%'};
  justify-content: space-between;
  flex-direction: ${props => props.column ? 'column' : 'row'};

`
export const TierInputNumber = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    display: none !important;
  }
  .ant-input-number-suffix {
    display: none;
  }
`
export const HybridDiv = styled.div`
  z-index: 1;
`
